var Curriculog = Curriculog || {};

Curriculog.ManageRolesView = (function ($, _, Backbone, ManageRolesView) {

    ManageRolesView = Curriculog.CurriculogView.extend({
        template: 'HierarchyFlyout/manageRoles.html',
        impactDialogTemplate: 'Dialog/roleImpact.html',

        events: {
            'change #role-type-dropdown': 'refreshCommitteeDropdown',
            'click #entity-role-add': 'validateNewRole',
            'click #entity-role-update': 'updateRoleInList',
            'click #entity-role-cancel': 'resetRoleForm',
            'click .entity-role-edit': 'edit',
            'click .entity-role-remove:not(.disabled):not(.type-replace)': 'checkDeletedRoleImpact',
            'click .entity-role-remove.disabled': 'disabledDelete',
        },

        mask: function () {
            return '#roles-for-entity-' + this.currentEntityID
        },

        initialize: function (options) {
            this.roles = options.roles;
            this.roleTypes = options.roleTypes;
            this.committees = options.committees;
            this.entityRoleCanDeletes = options.entityRoleCanDeletes;
            this.currentRoleID = null;
            this.currentEntityID = options.currentEntityID;
            this.params = options.params;
            this.listenTo(this.roles, 'change', this.render);
            this.listenTo(this.roles, 'add', this.render);
            this.listenTo(this.roles, 'remove', this.render);
            this.listenTo(this.roles, 'new-role', this.render);
            this.render();
        },

        render: function () {
            var templateData = {
                entityID: this.currentEntityID
            }
            var el = nunjucks.render(this.template, templateData);
            this.replaceElement(el);
            this.renderRoleTypeDropdown();
            var disabledList = this.roles.getRoleTypeIDsForEntity(this.currentEntityID);
            this.refreshRoleTypeDropdown(disabledList);
            this.renderCommitteeDropdown();
            this.refreshCommitteeDropdown();
            this.renderRoleList();
        },

        renderRoleTypeDropdown: function () {
            var subView = new Curriculog.DropdownView({
                collection: this.roleTypes,
                id: 'role-type-dropdown',
            });
            var roleTypeLabel = this.$el.find('label')[1];
            $(subView.el).insertAfter(roleTypeLabel);
            this.roleTypeDropdown = subView;
        },

        renderCommitteeDropdown: function () {
            var subView = new Curriculog.DropdownView({
                collection: this.committees,
                id: 'committee-dropdown',
            });
            var element = '<option value="">No Committee</option>'
            $(subView.el).prepend(element);

            var committeeLabel = this.$el.find('label')[2];
            $(subView.el).insertAfter(committeeLabel);
            this.committeeDropdown = subView;
        },

        refreshCommitteeDropdown: function () {
            if (this.committeeDropdown) {
                $(this.committeeDropdown.el).find('option:eq(0)').prop('selected', true);

                var roleTypeID = this.roleTypeDropdown.getCurrentSelection();
                var roleType = this.roleTypes.get(roleTypeID);

                if (roleType.get('committee') === 0) {
                    $(this.committeeDropdown.el).attr('disabled', true);
                } else {
                    $(this.committeeDropdown.el).attr('disabled', false);
                }
            }
        },

        refreshRoleTypeDropdown: function (disabledList) {
            // the Originator role type MUST be disabled
            disabledList.push(1);

            this.roleTypeDropdown.eachDropdownItem(function (itemView) {
                if (_.contains(disabledList, itemView.item.id)) {
                    itemView.setDisabled(true);
                } else {
                    itemView.setDisabled(false);
                }
            });

            var newSelectedItem = $(this.roleTypeDropdown.el).find('option:not(:disabled):first');

            if (typeof newSelectedItem.val() === 'undefined') {
                $(this.roleTypeDropdown.el).find('option:eq(0)').prop('selected', true);
                $(this.roleTypeDropdown.el).attr('disabled', true);
            } else {
                newSelectedItem.prop('selected', true);
            }
        },

        removeErrors: function () {
            var errorMessages = this.$el.find('#entity-roles-form > span.error');

            for (var i = 0; i < errorMessages.length; i++) {
                $(errorMessages[i]).remove();
            }
        },

        showNameRequiredError: function () {
            this.$el.find('#entity-role-name').val('');
            var errorMessages = this.$el.find('#entity-roles-form > span.error');
            if (errorMessages.length <= 0) {
                var element = '<span for="entity-role-name" class="error">This field is required.</span>';
                $(element).insertAfter('#entity-role-name');
            }
        },

        edit: function (event) {
            event.preventDefault();
            var updateButton = this.$el.find('#entity-role-update');
            var createButton = this.$el.find('#entity-role-add');
            var nameField = this.$el.find('#entity-role-name');

            createButton.prop('disabled', 'disabled');
            createButton.attr('style', 'display:none');
            updateButton.prop('disabled', false);
            updateButton.removeAttr('style');

            var role = this.getClickedRole(event);
            var sanitizedRole = role.getSanitizedModel();

            this.currentRoleID = role.get('id');

            nameField.val(sanitizedRole.get('name'));

            this.roleTypeDropdown.changeCurrentSelection(role.get('role_type_id'));
            this.$el.find('#role-type-dropdown').prop('disabled', false);

            if (role.get('committee_id')) {
                this.committeeDropdown.changeCurrentSelection(role.get('committee_id'));
                this.$el.find('#committee-dropdown').prop('disabled', false);
            } else {
                this.refreshCommitteeDropdown();
            }

            var canDelete = this.entityRoleCanDeletes[this.currentRoleID];
            if (canDelete === false) {
                this.$el.find('#role-type-dropdown').prop('disabled', 'disabled');
                this.$el.find('#committee-dropdown').prop('disabled', 'disabled');
            }
        },

        updateRole: function (roleValues, callback) {
            var view = this;
            if (roleValues['name'].length > 0) {
                var role = this.roles.get(roleValues['id']);
                var oldRoleTypeID = role.get('role_type_id');
                var oldCommitteeID = role.get('committee_id');
                roleValues['old_role_type_id'] = oldRoleTypeID;
                roleValues['old_committee_id'] = oldCommitteeID;
                role.save(roleValues, {
                    wait: true,

                    error: function () {
                        $('#entity-role-name').val(role.get('name'));

                        var errorText = 'An error was encountered when updating the role.  ';
                        errorText += 'The role name has not been changed.  Please try again '
                        errorText += 'or contact an administrator.';
                        view.showGrowl(errorText);
                    },

                    success: function (model, response) {
                        var oldRoleType = view.roleTypes.get(oldRoleTypeID);

                        // reset old role type's canDelete
                        oldRoleType.set('canDelete', response.old_role_type_can_delete);

                        // set new role type's canDelete to false
                        roleType = view.roleTypes.get(role.get('role_type_id'));
                        roleType.set('canDelete', false);

                        if (oldCommitteeID) {
                            var oldCommittee = view.committees.get(oldCommitteeID);

                            // reset old committee's canDelete
                            oldCommittee.set('canDelete', response.old_committee_can_delete);
                        }

                        committeeID = role.get('committee_id');
                        if (committeeID) {
                            // set new committee's canDelete to false
                            committee = view.committees.get(committeeID);
                            committee.set('canDelete', false);
                        }

                        role.unset('old_committee_can_delete');
                        role.unset('old_role_type_can_delete');
                        role.unset('old_committee_id');
                        role.unset('old_role_type_id');
                        role.unset('role_id');

                        callback && callback();
                    },
                });
            }
        },

        updateRoleInList: function () {
            var roleValues = this.getUpdatedRoleValues();
            if (roleValues['name'].trim().length > 0) {
                this.updateRole(roleValues);
                this.removeErrors()
            } else {
                this.showNameRequiredError();
            }
        },

        getUpdatedRoleValues: function () {
            var newName = this.$el.find('#entity-role-name').val();

            roleValues = {};
            roleValues['id'] = parseInt(this.currentRoleID);
            roleValues['name'] = newName;

            var canDelete = this.entityRoleCanDeletes[this.currentRoleID];

            if (canDelete) {
                var roleTypeID = this.roleTypeDropdown.getCurrentSelection();
                roleValues['role_type_id'] = parseInt(roleTypeID);
                var roleType = this.roleTypes.get(roleTypeID);
                roleValues['committee_id'] = null;

                if (roleType.get('committee') === 1) {
                    var committeeID = this.committeeDropdown.getCurrentSelection();

                    if (committeeID){
                        roleValues['committee_id'] = parseInt(committeeID);
                    }
                }
            }

            return roleValues;
        },

        disabledDelete: function(event) {
            event.preventDefault();
        },

        getClickedRole: function (event) {
            var roleID = $(event.target).closest('li').find('[name="id"]').val();
            roleID = parseInt(roleID);
            return this.roles.get(roleID);
        },

        renderRoleList: function () {
            // get a list of all roles for this entity
            entityRoles = this.roles.getRoleObjectsForEntity(this.currentEntityID);
            entityRoles = entityRoles.sort(function (a, b) {
                if (a.name.toLowerCase() < b.name.toLowerCase())
                    return -1;
                if (a.name.toLowerCase() > b.name.toLowerCase())
                    return 1;
                return 0;
            });

            // add committee name information to each object
            var view = this;
            entityRoles.forEach(function (item, index) {
                if (item.committee_id !== null) {
                    var committee = view.committees.get(item.committee_id);
                    item.committee_name = committee.get('name');
                } else {
                    item.committee_name = null;
                }
            });

            var subView = new Curriculog.RoleListView({
                items: entityRoles,
                entityRoleCanDeletes: this.entityRoleCanDeletes,
                params: this.params
            });

            var rolesLabel = this.$el.find('.label')[0];
            $(subView.el).insertAfter(rolesLabel);
            this.roleList = subView;
        },

        resetRoleForm: function () {
            this.currentRoleID = null;
            var updateButton = this.$el.find('#entity-role-update');
            var createButton = this.$el.find('#entity-role-add');

            updateButton.prop('disabled', 'disabled');
            updateButton.attr('style', 'display:none');
            createButton.prop('disabled', false);
            createButton.removeAttr('style');

            this.$el.find('#entity-role-name').val('');
            $(this.roleTypeDropdown.el).attr('disabled', false);

            var disabledList = this.roles.getRoleTypeIDsForEntity(this.currentEntityID);
            this.refreshRoleTypeDropdown(disabledList);
            this.refreshCommitteeDropdown();
            this.removeErrors();
        },

        buildImpactedStepList: function (stepImpact, proposalsByID) {
            var impactedSteps = [];
            _.each(stepImpact, function(item) {
                var proposalData = proposalsByID[item.proposal_id];

                impactedSteps.push({
                    proposalName: proposalData.name,
                    hasEmptyStep: item.has_empty_step,
                 });
            });

            return impactedSteps;
        },

        generateDialogTemplateData: function (data, action) {
            var proposalsByID = data.proposal_data.proposals_by_id;

            var impactedFutureSteps = this.buildImpactedStepList(
                data.proposal_data.future_step_impact,
                proposalsByID
            );

            var impactedCurrentSteps = this.buildImpactedStepList(
                data.proposal_data.current_step_impact,
                proposalsByID
            );

            var sortedFutureSteps = _.sortBy(impactedFutureSteps, function(item) {
                return item.proposalName;
            });

            var sortedCurrentSteps = _.sortBy(impactedCurrentSteps, function(item) {
                return item.proposalName;
            });

            return {
                num_steps: data.num_current_steps + data.num_future_steps,
                num_proposals: data.num_proposals,
                num_current_steps: data.num_current_steps,
                num_future_steps: data.num_future_steps,
                future_step_impact: sortedFutureSteps,
                current_step_impact: sortedCurrentSteps,
                action: action,
            }
        },

        checkDeletedRoleImpact: function (event) {
            event.preventDefault();
            var view = this;
            var roleModel = this.getClickedRole(event);

            $.ajax({
                type: 'DELETE',
                url: 'rest/hierarchyroleimpact/' + roleModel.get('id'),

                error: function() {
                    var errorText = 'An error was encountered when deleting the role.  ';
                    errorText += 'The role has not been deleted.  Please try again '
                    errorText += 'or contact an administrator.';
                    view.showGrowl(errorText);
                },

                success: function (data) {
                    // only show the dialog if there are affected steps
                    if (data.num_current_steps + data.num_future_steps > 0) {
                        var templateData = view.generateDialogTemplateData(data, 'deleting');
                        var msg = nunjucks.render(view.impactDialogTemplate, templateData);
                    } else {
                        var msg = 'Are you sure you want to delete the ' + roleModel.get('name') + ' role?';
                    }

                    new Curriculog.SimpleConfirmDialog({
                        message: msg,
                        confirmCallback: function () {
                            this.close();
                            view.delete(roleModel);
                        },
                    });
                },
            });
        },

        delete: function (roleModel) {
            var view = this;
            var committeeID = roleModel.get('committee_id');
            var roleTypeID = roleModel.get('role_type_id');

            $.ajax({
                type: 'POST',
                url: '/gearman-job.json',
                contentType: 'application/json',
                mask: view.mask(),
                data: JSON.stringify({
                    functionName: 'delete_role_task',
                    workload: {
                        method_args: roleModel,
                    }
                }),

                beforeSend: function () {
                    domObject.addLoadingMask(this.mask);
                },

                success: function (results) {
                    getBackgroundJobStatus(
                        results.jobHandle,
                        this.mask,
                        'Delete Role',
                        function (result) {
                            view.roles.remove(roleModel);

                            if (committeeID !== null &&
                                view.roles.getRolesByCommittee(committeeID).length === 0) {
                                var committee = view.committees.get(committeeID);
                                committee.set('canDelete', true);
                            }
                            var roleType = view.roleTypes.get(roleTypeID);
                            roleType.fetch();

                            if (view.currentRoleID > 0) {
                                // we are in the role flyout, so after deleting we need to close
                                closeFlyout();
                            }

                            Curriculog.Actions.log('entity-role-deleted');
                        },
                        function(jobResults){
              						var taskName = 'Delete Role';
              						$('#growls').notify("create","warning-template", {
              							title: 'Warning',
              							text: 'An error occurred while attempting to ' + taskName + '. Please try again or contact a system administrator.',
              						}, {
              							expires: false,
              						});
              					}
                    );
                },

                error: function () {
                    domObject.removeMask(this.mask);

                    var errorText = 'An error was encountered when deleting the role.  ';
                    errorText += 'The role has not been deleted.  Please try again '
                    errorText += 'or contact an administrator.';
                    view.showGrowl(errorText);
                },
            });
        },

        validateNewRole: function () {
            var view = this;
            var nameInput = this.$el.find('#entity-role-name').val();

            if (nameInput === '' || nameInput.trim().length <= 0) {
                this.showNameRequiredError();
            } else {
                var selectedElement = $(this.roleTypeDropdown.el).find('option:selected');

                // Do not allow a new role to be created if all role types have
                // been used for this entity.
                if (selectedElement.attr('disabled')) {
                    return;
                }

                var roleTypeID = selectedElement.val();
                roleTypeID = parseInt(roleTypeID);
                var committeeID = this.committeeDropdown.getCurrentSelection() || null;

                var roleData = {
                    role_type_id: roleTypeID,
                    entity_id: this.currentEntityID,
                    name: nameInput,
                    status: 'active',
                    committee_id: parseInt(committeeID),
                }

                // show a dialog if the role has a committee role type but
                // no committee has been selected
                var roleType = this.roleTypes.get(roleTypeID);
                if (roleType.get('committee') === 1 && committeeID === null) {
                    msg = 'You have selected a committee role type for this role without assigning it a committee.  Are you sure you want to continue?';
                    new Curriculog.SimpleConfirmDialog({
                        message: msg,
                        confirmButtonText: 'Save Role',
                        confirmCallback: function () {
                            view.checkNewRoleImpact(roleData);
                            this.close();
                        },
                    });
                } else {
                    this.checkNewRoleImpact(roleData);
                }
            }
        },

        checkNewRoleImpact: function (roleData) {
            var view = this;

            $.ajax({
                type: 'POST',
                url: 'rest/hierarchyroleimpact/',
                data: roleData,

                error: function() {
                    var errorText = 'An error was encountered when creating the role.  ';
                    errorText += 'The role has not been created.  Please try again '
                    errorText += 'or contact an administrator.';
                    view.showGrowl(errorText);
                },

                success: function (data) {
                    // only show the dialog if there are affected steps
                    if (data.num_current_steps + data.num_future_steps > 0) {
                        var templateData = view.generateDialogTemplateData(data, 'creating');
                        var msg = nunjucks.render(view.impactDialogTemplate, templateData);

                        new Curriculog.SimpleConfirmDialog({
                            message: msg,
                            confirmCallback: function () {
                                this.close();
                                view.createNewRole(roleData);
                            },

                            cancelCallback: function () {
                                this.close();
                                view.resetRoleForm();
                            },
                        });
                    } else {
                        // No need to show the dialog if there are no affected steps
                        view.createNewRole(roleData);
                    }
                },
            });
        },

        createNewRole: function (roleData) {
            var view = this;

            $.ajax({
                type: 'POST',
                url: '/gearman-job.json',
                contentType: 'application/json',
                mask: '#roles-for-entity-' + this.currentEntityID,
                data: JSON.stringify({
                    functionName: 'create_role_task',
                    workload: {
                        method_args: roleData,
                    }
                }),

                beforeSend: function () {
                    domObject.addLoadingMask(this.mask);
                },

                success: function (results) {
                    getBackgroundJobStatus(
                        results.jobHandle,
                        this.mask,
                        'Create Role',
                        function (result) {
                            // create a model for the new role
                            var model = new Curriculog.Role(result.model)

                            // add the role to the collection
                            view.roles.add(model);

                            // reset committee can delete
                            if (roleData.committee_id) {
                                var committee = view.committees.get(roleData.committee_id);
                                committee.set('canDelete', false);
                            }

                            // reset role type can delete
                            var roleType = view.roleTypes.get(roleData.role_type_id);
                            roleType.set('canDelete', false);

                            view.entityRoleCanDeletes[model.get('id')] = true;

                            // refresh the view
                            view.roles.trigger('new-role', model);
                            var disabledList = view.roles.getRoleTypeIDsForEntity(view.currentEntityID);
                            view.refreshRoleTypeDropdown(disabledList);

                            Curriculog.Actions.log('entity-role-created')
                        },
                        function(jobResults){
              						var taskName = 'Create Role';
              						$('#growls').notify("create","warning-template", {
              							title: 'Warning',
              							text: 'An error occurred while attempting to ' + taskName + '. Please try again or contact a system administrator.',
              						}, {
              							expires: false,
              						});
              					}
                    );
                },

                error: function () {
                    domObject.removeMask(this.mask);

                    var errorText = 'An error was encountered when creating the role.  ';
                    errorText += 'The role has not been created.  Please try again '
                    errorText += 'or contact an administrator.';
                    view.showGrowl(errorText);
                },
            });
        },
    });
    return ManageRolesView;

})($, _, Backbone, Curriculog.ManageRolesView || {});
